import { render, staticRenderFns } from "./BusinessPage.vue?vue&type=template&id=8e9c55d8&scoped=true"
import script from "./BusinessPage.vue?vue&type=script&lang=js"
export * from "./BusinessPage.vue?vue&type=script&lang=js"
import style0 from "./BusinessPage.vue?vue&type=style&index=0&id=8e9c55d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9c55d8",
  null
  
)

export default component.exports